import { Users, Armchair, Waves } from "lucide-react";
import { Reveal } from "./Reveal";
import { ACCESS_POINTS } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

const ICONS = { Users, Armchair, Waves };

export const GoodToKnow = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="access-section"
      className="bg-primary text-primary-foreground py-16 md:py-20"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-10 md:gap-14">
          {ACCESS_POINTS.map((p, i) => {
            const Icon = ICONS[p.icon] || Users;
            const copy = t.access[i] || p;
            return (
              <Reveal
                key={p.icon}
                delay={i * 0.1}
                data-testid={`access-point-${i}`}
                className="flex flex-col gap-4"
              >
                <Icon size={30} className="text-accent" strokeWidth={1.5} />
                <h3 className="font-serif text-2xl md:text-3xl">{copy.title}</h3>
                <p className="text-primary-foreground/75 font-light leading-relaxed">
                  {copy.desc}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
